import { render, staticRenderFns } from "./UniversityListDialog.vue?vue&type=template&id=d345336e&scoped=true"
import script from "./UniversityListDialog.vue?vue&type=script&lang=js"
export * from "./UniversityListDialog.vue?vue&type=script&lang=js"
import style0 from "./UniversityListDialog.vue?vue&type=style&index=0&id=d345336e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d345336e",
  null
  
)

export default component.exports